import { useEffect } from "react";

import { useGetMaterialData } from "../../hooks";
import { getCachedItem, setCachedItem } from "../../helpers";
import { setMaterialsSnapshot } from "../../tables/DipsTable/helper";

let hydrated = false;

export const useMaterialListWithCache = () => {
  const cachedData = hydrated ? getCachedItem("materials") : false;
  const { data, isLoading, isSuccess } = useGetMaterialData(!cachedData);
  const materials = cachedData || data || [];

  useEffect(() => {
    if (data && isSuccess) {
      hydrated = true;
      setCachedItem("materials", data);
      setMaterialsSnapshot(data);
    }
  }, [data, isSuccess]);

  return { materials: materials || [], isLoading, isSuccess };
};
